module.exports = __webpack_public_path__ + "static/img/grow3.1e5da8a4.png";